module.exports = vendor_9144673b21133fc50009;


//////////////////
// WEBPACK FOOTER
// external "vendor_9144673b21133fc50009"
// module id = 8kch
// module chunks = 0